import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import {Nav, NavItem, NavLink, Button} from 'reactstrap';
import Navy from './components/Navy';
import Home from './components/Home';
import Footer from './components/Footer';
import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Navy/>
            <Route exact path='/' component={Home}/>
          <Footer/>
        </div>
      </Router>
      
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js